import { ReactNode } from 'react'
import clsx from 'clsx'

/* blocks */
import Header from '@/cmp/molecules/Header/Header'
import Seo from '@/molecules/SEO/SEO'
import Footer from '@/cmp/molecules/Footer/Footer'

/* utils */
import { inter } from '@/styles/fonts/fonts'

interface Meta {
  property: string
  content: string
}

interface Props {
  children: ReactNode
  title: string
  meta?: Meta[]
  canonical?: string
  primaryCta?: { title: string; url: string }
  secondaryCta?: { title: string; url: string }
  tertiaryCta?: { title: string; url: string }
  jsonSchema?: LDJsonSchema[]
  showNavLinks?: boolean
  noIndex?: boolean
  mode?: 'dark' | 'light'
}

function Layout({
  title,
  meta,
  children,
  canonical = '',
  jsonSchema,
  showNavLinks = true,
  noIndex = false
}: Props) {
  return (
    <div className={clsx(inter.className, inter.variable)}>
      <Seo
        title={title}
        meta={meta}
        canonical={canonical}
        jsonSchema={jsonSchema}
        noIndex={noIndex}
      />
      <Header />
      <main data-test-id="main">{children}</main>

      {showNavLinks && <Footer />}
    </div>
  )
}

export default Layout
